<template>
  <q-menu :auto-close="false" transition-duration="100" @hide="applyRange('hide')">
    <q-card flat>
      <q-card-section class="q-gutter-sm">
        <div class="title q-pb-xs">{{ title }}</div>
        <div class="row">
          <q-input
            v-model.number="min"
            class="q-mr-sm"
            label="Min"
            dense
            outlined
            hide-bottom-space
            type="number"
            style="width: 100px"
            :rules="[isMinValid]"
            @update:model-value="noApplyBtn && applyRange('update-range')"
            @blur="scrubMinInput"
          />
          <q-input
            v-model.number="max"
            label="Max"
            dense
            outlined
            hide-bottom-space
            type="number"
            style="width: 100px"
            :rules="[isMaxValid]"
            @update:model-value="noApplyBtn && applyRange('update-range')"
            @blur="scrubMaxInput"
          />
        </div>
      </q-card-section>
      <q-separator />
      <q-card-actions align="right">
        <q-btn v-close-popup unelevated dense label="Clear" no-caps @click="clearRange" />
        <q-btn
          v-if="!noApplyBtn"
          v-close-popup="isRangeValid()"
          unelevated
          dense
          label="Apply"
          color="primary"
          no-caps
          @click="applyRange('update-range')"
        />
      </q-card-actions>
    </q-card>
  </q-menu>
</template>

<script lang="ts">
import type { PropType } from 'vue'

export default {
  name: 'MinMaxPopover',
  props: {
    title: {
      type: String as PropType<string>,
      required: true
    },
    noApplyBtn: {
      type: Boolean as PropType<boolean>,
      required: true
    }
  },
  emits: ['update-range', 'hide'],
  data() {
    return {
      min: null as number | string | null,
      max: null as number | string | null
    }
  },
  methods: {
    isMinValid(value: number): boolean | string {
      if (this.min === null || this.max === null) {
        return true
      }
      return value <= this.max || 'Exceeds maximum'
    },
    isMaxValid(value: number): boolean | string {
      if (this.min === null || this.max === null) {
        return true
      }
      return value >= this.min || 'Below minimum'
    },
    isRangeValid(): boolean {
      return this.isMinValid(this.min) === true && this.isMaxValid(this.max) === true
    },
    applyRange(eventName: string) {
      if (this.isRangeValid()) {
        this.$emit(eventName, { min: this.min, max: this.max })
      }
    },
    clearRange() {
      this.min = null
      this.max = null
      this.$emit('update-range', { min: this.min, max: this.max })
    },
    scrubMinInput() {
      if (this.min === '') {
        this.min = null
      }
      if (this.min < 0) {
        this.min = 0
      }
    },
    scrubMaxInput() {
      if (this.max === '') {
        this.max = null
      }
      if (this.max < 0) {
        this.max = 0
      }
    }
  }
}
</script>

<style scoped>
.title {
  font-size: 17px;
  font-weight: 500;
}
</style>
